import React from 'react';
import './Header.css'; // Add this import


const Header = () => {
  return (
    <header>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <svg className="header-logo" width="55" height="55" viewBox="0 0 52.4599760055542 64.80000000000001" >
              <g transform="translate(-7.51980471611023, -1.35) scale(1.35)" fill="#393e46">
                <g xmlns="http://www.w3.org/2000/svg">
                  <path d="M26.9,27c0,0.8-0.5,1.5-1.1,1.7v2.7h-1.4v-2.7c-0.6-0.2-1.2-0.9-1.2-1.7c0-0.9,0.8-1.9,1.9-1.9   C26.1,25.1,26.9,26.1,26.9,27z"></path>
                  <path d="M28.3,20.5v2.4h-6.7v-2.4c0-1.9,1.6-3.3,3.3-3.3C26.7,17.2,28.3,18.6,28.3,20.5z"></path>
                  <path d="M25,7.5c-2.8,2.9-7.6,6.6-15.4,10.3c0.3,5.2,2.1,17.7,13.5,26.6c0.5,0.4,1.2,0.6,1.9,0.6c0.7,0,1.4-0.2,1.9-0.7   C38.2,35.5,40.1,23,40.4,17.8C32.6,14.1,27.8,10.3,25,7.5z M29.2,34.4h-8.4c-1.2,0-2.2-1-2.2-2.2v-7.7c0-0.9,0.7-1.5,1.5-1.5v-2.4   c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9v2.4h0c0.8,0,1.5,0.7,1.5,1.5v7.7C31.4,33.4,30.4,34.4,29.2,34.4z"></path>
                  <path d="M44.4,15.2C28.3,8.1,25,1,25,1S21.7,8.1,5.6,15.2c0,0-1.4,19.5,15,32.3c2.5,2,6.2,2,8.7,0C45.8,34.7,44.4,15.2,44.4,15.2z    M28.1,45.9c-0.9,0.7-2,1.1-3.1,1.1c-1.1,0-2.3-0.4-3.1-1.1C8.7,35.6,7.6,20.8,7.6,16.5c10.1-4.6,15.1-9.2,17.4-12   c2.3,2.8,7.4,7.4,17.4,12C42.4,20.8,41.2,35.7,28.1,45.9z"></path>
                  <path d="M26.9,27c0,0.8-0.5,1.5-1.1,1.7v2.7h-1.4v-2.7c-0.6-0.2-1.2-0.9-1.2-1.7c0-0.9,0.8-1.9,1.9-1.9   C26.1,25.1,26.9,26.1,26.9,27z"></path>
                  <path d="M28.3,20.5v2.4h-6.7v-2.4c0-1.9,1.6-3.3,3.3-3.3C26.7,17.2,28.3,18.6,28.3,20.5z"></path>
                  <path d="M25,7.5c-2.8,2.9-7.6,6.6-15.4,10.3c0.3,5.2,2.1,17.7,13.5,26.6c0.5,0.4,1.2,0.6,1.9,0.6c0.7,0,1.4-0.2,1.9-0.7   C38.2,35.5,40.1,23,40.4,17.8C32.6,14.1,27.8,10.3,25,7.5z M29.2,34.4h-8.4c-1.2,0-2.2-1-2.2-2.2v-7.7c0-0.9,0.7-1.5,1.5-1.5v-2.4   c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9v2.4h0c0.8,0,1.5,0.7,1.5,1.5v7.7C31.4,33.4,30.4,34.4,29.2,34.4z"></path>
                  <path d="M26.9,27c0,0.8-0.5,1.5-1.1,1.7v2.7h-1.4v-2.7c-0.6-0.2-1.2-0.9-1.2-1.7c0-0.9,0.8-1.9,1.9-1.9   C26.1,25.1,26.9,26.1,26.9,27z"></path>
                  <path d="M28.3,20.5v2.4h-6.7v-2.4c0-1.9,1.6-3.3,3.3-3.3C26.7,17.2,28.3,18.6,28.3,20.5z"></path>
                  <path d="M25,7.5c-2.8,2.9-7.6,6.6-15.4,10.3c0.3,5.2,2.1,17.7,13.5,26.6c0.5,0.4,1.2,0.6,1.9,0.6c0.7,0,1.4-0.2,1.9-0.7   C38.2,35.5,40.1,23,40.4,17.8C32.6,14.1,27.8,10.3,25,7.5z M29.2,34.4h-8.4c-1.2,0-2.2-1-2.2-2.2v-7.7c0-0.9,0.7-1.5,1.5-1.5v-2.4   c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9v2.4h0c0.8,0,1.5,0.7,1.5,1.5v7.7C31.4,33.4,30.4,34.4,29.2,34.4z"></path>
                </g>
              </g>
            </svg>
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a href="/" className="nav-link active" aria-current="page">Inicio</a>
              </li>
              <li className="nav-item">
              <a href="/info" className="nav-link active" aria-current="page">Información</a>
              </li>          
            </ul>    
          </div>
        </div>
      </nav>

    </header>
  
  );
};

export default Header;